


































































































































































































import { Component, Vue, Watch} from 'vue-property-decorator';
let watermark = require('watermarkjs');
@Component({
  $_veeValidate: { validator: 'new' },
})
export default class ResumenConfirmar extends Vue {

  private citaSelected = this.$store.getters.getCita;
  private nombresServicios = '';
  private textoNotas = '';
  private nombreMascota = '';
  private tiendaElegidaNombre = '';
  private nombreGroomer = '';
  private fotoVacBorde = '';
  private fotoVacMulti = '';
  private fotoVacRabia = '';
  private dialog = false;
  private citaId = '';
  private validos = false;
  private validS2 = false;
  private validS3 = false;
  private validS4 = false;
  private visiblePhoto = 'd-none';
  private visiblePhoto2 = 'd-none';
  private statusCita: any; // Estatus actual de la cita
  /* Imágenes */
  private nombreI = '';
  private nombreF = '';
  private imagenMascotaEntrada: any = [];
  private imagenMascotaSalida: any = [];
  private commentI = '';
  private commentF = '';
  private url1 = ''; // Guardar urls de imágenes insertadas
  private url2 = '';
  private e1 = 0; // Stepper
  /*SnackBar*/
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2000;

  /**
   * Methods
   */
  private created() {
    this.nombresServicios = this.citaSelected.OBSERVACION;
    this.textoNotas = this.citaSelected.INST_ESPEC;
    this.nombreMascota = this.citaSelected.PET_NAME;
    this.tiendaElegidaNombre = this.citaSelected.TIENDA_TXT;
    this.citaId = this.citaSelected.ID_CITA;
    this.nombreGroomer = this.citaSelected.GRO_NOMBRE + ' ' + this.citaSelected.GRO_APEMAT;
    this.fotoVacBorde = this.citaSelected.urlVacBorde;    
    this.fotoVacMulti = this.citaSelected.urlVacMulti;
    this.fotoVacRabia = this.citaSelected.urlVacRabia;
  }

  private parseHours() {
    if (this.citaSelected.HORA_INI !== '' && this.citaSelected.HORA_FIN !== '') {
      let horaI = this.citaSelected.HORA_INI.substring(0, 2);
      let minI = this.citaSelected.HORA_INI.substring(2, 4);
      let horaF = this.citaSelected.HORA_FIN.substring(0, 2);
      let minF = this.citaSelected.HORA_FIN.substring(2, 4);
      return horaI + ':' +minI + ' - ' + horaF + ':' +minF;
    } else {
      return '';
    }
  }

  private sendEmail() {
    alert("Email enviado");
    this.validS3 = true;
  }

  private finalizarProceso() {
    if (this.validS2 && this.validS3 && this.validS4) {
      // Armamos el arreglo para guardar las fotos y comentarios
      const urlInicial = this.url1.split('?');
      const urlFinal = this.url2.split('?');
      let arrayGuardar = {
        idCita: this.citaId,
        urlFotoAntes: urlInicial[0],
        urlFotoDespues: urlFinal[0],
        comentAntes: this.commentI,
        comentDespues: this.commentF
      }
      this.validS4 = false;
      this.$store.dispatch('seguimiento', arrayGuardar)
      .then((resultado: any) => {
        if (resultado.replyCode === 200) {
          // this.$store
          this.$router.push('/citasGroomer');
        } else {
          this.validS4 = true;
        }
      })
      .catch((error: any) => {
        this.validS4 = true;
      });
    }
  }

  private pickFile(value: any) {
    // @ts-ignore
    value === 1 ? this.$refs.image.click() : this.$refs.image2.click();
  }

  private onMascotaEntrada (e: any) {
    let imageFile: any = [];
    let imagenNueva: any = [];
    const files = e.target.files;
    if(files[0] !== undefined && files[0].size !== 'undefined') {
      imageFile = files[0] // Imagen válida y lista para subirse
      this.nombreI = imageFile.name;
      const extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
      imageFile.newName = this.citaId + '-inicio' + extension;
        this.$store.dispatch('uploadImage', [imageFile])
        .then((valor: any) => {
          const PROD_URL = 'https://citas.petco.com.mx';
          // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
          const link = PROD_URL;
          const nombre = link + '/' + valor[0];
          this.url1 = link + '/' + valor[0] + '?date=' + new Date();
          const options = {
            init(img: any) {
              img.crossOrigin = 'anonymous'
            }
          };
          watermark([nombre+ '?date=' + new Date(), 'http://srvwebpet.petco.com.mx/imagenes/watermark.png'], options)
          .image(watermark.image.lowerLeft())
          .then((img: any) => {
            //console.log(img)
            this.url1=img.src;

          })
          .catch((error: any) => console.log(error));
          // this.url1 = img;
          this.visiblePhoto = '';
          this.validS2 = true;
      });
    } else {
      imageFile = [];
      this.url1 = '';
      this.visiblePhoto = 'd-none';
      this.validS2 = false;
    }
  }

  private onMascotaSalida (e: any) {
    let imageFile: any = [];
    const files = e.target.files
    if(files[0] !== undefined && files[0].size !== 'undefined') {
      imageFile = files[0] // Imagen válida y lista para subirse
      this.nombreF = imageFile.name;
      const extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
      imageFile.newName = this.citaId + '-terminado' + extension;
      this.$store.dispatch('uploadImage', [imageFile])
      .then((valor: any) => {
        const DEV_URL = 'http://localhost';
        const PROD_URL = 'https://citas.petco.com.mx';
        // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
        const link = PROD_URL;
        this.url2 = link + '/' + valor[0] + '?date=' + new Date();
        this.visiblePhoto2 = '';
        this.validS4 = true;
      });
    } else {
      let imageFile = [];
      this.url2 = '';
      this.visiblePhoto2 = 'd-none';
      this.validS4 = false;
    }
  }

  private formatDate(fecha: any) {
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
    let mesString = '';
    if (mes === '01') {
      mesString = 'Enero';
    } else if (mes === '02') {
      mesString = 'Febrero';
    } else if (mes === '03') {
      mesString = 'Marzo';
    } else if (mes === '04') {
      mesString = 'Abril';
    } else if (mes === '05') {
      mesString = 'Mayo';
    } else if (mes === '06') {
      mesString = 'Junio';
    } else if (mes === '07') {
      mesString = 'Julio';
    } else if (mes === '08') {
      mesString = 'Agosto';
    } else if (mes === '09') {
      mesString = 'Septiembre';
    } else if (mes === '10') {
      mesString = 'Octubre';
    } else if (mes === '11') {
      mesString = 'Noviembre';
    } else if (mes === '12') {
      mesString = 'Diciembre';
     }
    return dia + ' / ' + mesString + ' / ' + anio;
  }

  // Escribe servicios
  private writeServicios(array: any) {
    let cadena = '';
    for (const m of array) {
      cadena += m.mascota+ ': ';
      for (const s of m.servicio) {
        cadena += s + ', ';
      }
      cadena = cadena.substring(0, cadena.length - 2);
      cadena += '; ';
    }
    return cadena.substring(0, cadena.length - 2);
  }

  // Escribe notas
  private writeNotas(array: any) {
    let cadena = '';
    for (const m of array) {
      cadena += m.mascota + ': ' + m.notas + '; ';
    }
    return cadena.substring(0, cadena.length - 2);
  }
}

